import React from "react";
import { Navigate } from "react-router-dom";

const CreditNoteAdd = React.lazy(
  () => import("../../../../../components/credit-note/components/add/page"),
);
const CreditNoteIssued = React.lazy(
  () => import("../../../../../components/credit-note/components/list/page"),
);

export const creditNotesRoutes = [
  {
    path: "add",
    element: <CreditNoteAdd />,
  },
  {
    path: "issued",
    element: <CreditNoteIssued />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/credit-notes/issued" />,
  },
];
